/**
 * A publish asked for now and sent once the running download or sync ends.
 * Many requests during one download send the event once.
 */
export interface PendingPublish {
  /** Asks to publish when the current download or sync ends. */
  request(): void;
  /** Publishes when asked to since the last flush. */
  flush(): void;
  /** Drops the request (the download was aborted). */
  cancel(): void;
}

export function createPendingPublish(publish: () => unknown): PendingPublish {
  let isRequested = false;
  return {
    request: () => {
      isRequested = true;
    },
    flush: () => {
      if (!isRequested) {
        return;
      }
      isRequested = false;
      void publish();
    },
    cancel: () => {
      isRequested = false;
    },
  };
}

